import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CollectionFormFieldValue } from 'src/models/ts/collection-form-field-value.model';

export interface ChecklistAnswer {
  QuestionVersionsID: number;
  ResultClassID?: number;
  ResultClassValueID?: number;
  Remarks?: string | null;
  Attachments?: AnswerAttachment[] | [];
  Value?: string | null;
}

export interface AnswerAttachment {
  Id: number; // MediaID
  Size: number; // filesize in Kb
  FileName: string; // filename
}

@Injectable({
  providedIn: 'root'
})
export class ChecklistApiService {

  private http = inject(HttpClient);

   public postChecklistQuestion(dataDesignViewDataSourcesId: number, versionId: number, payload: ChecklistAnswer): Observable<void> {
    return this.http.post<void>(`api/checklist/viewdatasourcesid/${dataDesignViewDataSourcesId}/version/${versionId}`, payload);
  }

  public addChecklistGroupValue(intent: {
    collectionFieldsId: number,
    languageId: number,
    caption: string,
  }): Observable<Array<CollectionFormFieldValue>> {
    return this.http.post<Array<CollectionFormFieldValue>>(`api/checklist/questiongroup`, {
      CollectionFieldsID: intent.collectionFieldsId,
      LanguageId: intent.languageId,
      Caption: intent.caption
    });
  }

  public downloadMedia(questionVersionId: number, mediaId: number): Observable<HttpResponse<ArrayBuffer>>{
     return this.http.post(`api/checklist/attachment/download/${mediaId}`, {},  {
       responseType: 'arraybuffer',
       observe: 'response',
     })
  }

}
